import './../applied_filter_view.js.coffee'

Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.AppliedGroupedElementsView extends Common.Dashboard.Filters.AppliedFilterView
  template: JST['backbone/templates/common/dashboard/filters/applied/grouped_elements/applied_grouped_elements']
  className: 'applied-group-elements'

  initialize: ({filter, titleClassName, isReadOnly}) ->
    super({filter, isReadOnly})
    @titleClassName = titleClassName

  render: =>
    super()
    @$('.applied-grouped-elements-title').addClass(@titleClassName)
    container = @$('.applied-grouped-elements-title-container')
    container.addClass('hidden') unless @_displayTitle()
    @

  shouldRender: ->
    @_displayValues().length > 0

  _renderTemplate: ->
    @$el.empty().append(@template({title: @_displayTitle()}))

  _displayTitle: ->
    throw new Error 'Not implemented'

  _displayValues: ->
    throw new Error 'Not implemented'

  _mapValues: (values) ->
    mapper = new CustomerVisualMode.Mappers.GroupsValuesMapper
    mapper.map(values)
